import { useParams, Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Breadcrumb from "@/components/base/Breadcrumb";
import { categories, articles, getArticleBySlug, getRelatedArticles } from "@/mocks/articles";

const articleDetailImageMap: Record<string, string> = {
  "article-01": "https://readdy.ai/api/search-image?query=Dramatic%20night%20scene%20of%20luxury%20hotel%20entrance%20with%20warm%20amber%20lights%2C%20blurred%20figures%2C%20cinematic%20composition%2C%20moody%20noir%20style%2C%20editorial%20photography&width=800&height=1000&seq=detail-01&orientation=portrait",
  "article-02": "https://readdy.ai/api/search-image?query=Luxurious%20wedding%20ceremony%20with%20elaborate%20floral%20arrangements%2C%20soft%20golden%20lighting%2C%20elegant%20banquet%20hall%2C%20romantic%20editorial%20style&width=800&height=1000&seq=detail-02&orientation=portrait",
  "article-03": "https://readdy.ai/api/search-image?query=Smartphone%20screen%20showing%20live%20streaming%20interface%2C%20colorful%20overlay%2C%20modern%20streaming%20setup%2C%20vibrant%20digital%20culture%2C%20documentary%20style&width=800&height=1000&seq=detail-03&orientation=portrait",
  "article-04": "https://readdy.ai/api/search-image?query=Split%20scene%20showing%20contrast%20between%20professional%20office%20and%20vibrant%20nightclub%2C%20dramatic%20lighting%2C%20cinematic%20conceptual%20portrait&width=800&height=1000&seq=detail-04&orientation=portrait",
  "article-05": "https://readdy.ai/api/search-image?query=Dimly%20lit%20private%20party%20with%20elegant%20interior%2C%20silhouettes%2C%20ambient%20lighting%2C%20luxurious%20penthouse%2C%20cinematic%20mood%20photography&width=800&height=1000&seq=detail-05&orientation=portrait",
  "article-06": "https://readdy.ai/api/search-image?query=Mysterious%20private%20club%20entrance%20with%20amber%20lighting%2C%20dark%20wood%20and%20brass%2C%20cinematic%20noir%20atmosphere%2C%20secretive%20vibe&width=800&height=1000&seq=detail-06&orientation=portrait",
  "article-07": "https://readdy.ai/api/search-image?query=Empty%20modern%20office%20at%20night%2C%20scattered%20documents%2C%20dim%20desk%20lamps%2C%20exhausted%20corporate%20atmosphere%2C%20documentary%20style&width=800&height=1000&seq=detail-07&orientation=portrait",
  "article-08": "https://readdy.ai/api/search-image?query=Determined%20young%20entrepreneur%20at%20simple%20desk%2C%20warm%20natural%20light%2C%20rustic%20background%2C%20hopeful%20golden%20hour%2C%20documentary%20portrait&width=800&height=1000&seq=detail-08&orientation=portrait",
  "article-09": "https://readdy.ai/api/search-image?query=Modern%20corporate%20building%20with%20overcast%20sky%2C%20clean%20architectural%20lines%2C%20serious%20mood%2C%20documentary%20style&width=800&height=1000&seq=detail-09&orientation=portrait",
  "article-10": "https://readdy.ai/api/search-image?query=Abstract%20digital%20network%20with%20warm%20amber%20nodes%2C%20dark%20background%2C%20modern%20data%20visualization%2C%20sophisticated%20tech%20aesthetic&width=800&height=1000&seq=detail-10&orientation=portrait",
  "article-11": "https://readdy.ai/api/search-image?query=Anonymous%20silhouette%20against%20computer%20glow%2C%20dark%20room%2C%20dramatic%20chiaroscuro%2C%20cyber%20mystery%2C%20thriller%20photography&width=800&height=1000&seq=detail-11&orientation=portrait",
  "article-12": "https://readdy.ai/api/search-image?query=Collage%20of%20newspaper%20headlines%20and%20digital%20news%20snippets%2C%20organized%20chaos%2C%20warm%20paper%20tones%2C%20editorial%20layout&width=800&height=1000&seq=detail-12&orientation=portrait",
};

const squareImageMap: Record<string, string> = {
  "article-01": "https://readdy.ai/api/search-image?query=Dramatic%20hotel%20night%20scene%2C%20amber%20lights%2C%20moody%20atmosphere%2C%20cinematic%20noir%2C%20editorial%20photography&width=500&height=500&seq=detail-sq-01&orientation=squarish",
  "article-02": "https://readdy.ai/api/search-image?query=Luxurious%20wedding%20floral%20arrangement%2C%20golden%20lighting%2C%20elegant%20banquet%20setting%2C%20romantic%20editorial&width=500&height=500&seq=detail-sq-02&orientation=squarish",
  "article-03": "https://readdy.ai/api/search-image?query=Live%20streaming%20smartphone%20interface%2C%20colorful%20overlay%2C%20modern%20digital%20culture%2C%20vibrant%20photography&width=500&height=500&seq=detail-sq-03&orientation=squarish",
  "article-04": "https://readdy.ai/api/search-image?query=Office%20to%20nightclub%20contrast%2C%20dramatic%20lighting%2C%20cinematic%20conceptual%20portrait%2C%20split%20scene&width=500&height=500&seq=detail-sq-04&orientation=squarish",
  "article-05": "https://readdy.ai/api/search-image?query=Private%20party%20elegant%20interior%2C%20silhouettes%2C%20ambient%20lighting%2C%20luxurious%20penthouse%2C%20cinematic%20mood&width=500&height=500&seq=detail-sq-05&orientation=squarish",
  "article-06": "https://readdy.ai/api/search-image?query=Private%20club%20entrance%20with%20amber%20lighting%2C%20dark%20wood%2C%20brass%20details%2C%20cinematic%20noir%2C%20secretive&width=500&height=500&seq=detail-sq-06&orientation=squarish",
  "article-07": "https://readdy.ai/api/search-image?query=Empty%20office%20at%20night%2C%20scattered%20documents%2C%20dim%20lamps%2C%20corporate%20exhaustion%2C%20documentary%20style&width=500&height=500&seq=detail-sq-07&orientation=squarish",
  "article-08": "https://readdy.ai/api/search-image?query=Young%20entrepreneur%20at%20desk%2C%20warm%20light%2C%20rustic%20background%2C%20hopeful%20golden%20hour%2C%20documentary%20portrait&width=500&height=500&seq=detail-sq-08&orientation=squarish",
  "article-09": "https://readdy.ai/api/search-image?query=Corporate%20building%20exterior%2C%20overcast%20sky%2C%20clean%20lines%2C%20serious%20mood%2C%20documentary%20architecture&width=500&height=500&seq=detail-sq-09&orientation=squarish",
  "article-10": "https://readdy.ai/api/search-image?query=Abstract%20digital%20network%2C%20warm%20amber%20nodes%2C%20dark%20background%2C%20sophisticated%20data%20visualization&width=500&height=500&seq=detail-sq-10&orientation=squarish",
  "article-11": "https://readdy.ai/api/search-image?query=Anonymous%20silhouette%2C%20computer%20glow%2C%20dark%20room%2C%20chiaroscuro%2C%20cyber%20mystery%2C%20thriller%20style&width=500&height=500&seq=detail-sq-11&orientation=squarish",
  "article-12": "https://readdy.ai/api/search-image?query=Newspaper%20headlines%20collage%2C%20organized%20chaos%2C%20warm%20paper%20tones%2C%20editorial%20layout%2C%20textured&width=500&height=500&seq=detail-sq-12&orientation=squarish",
};

const testimonialImageMap: Record<string, string> = {
  "article-06": "https://readdy.ai/api/search-image?query=Black%20and%20white%20portrait%20of%20a%20serious%20journalist%20in%20profile%2C%20dramatic%20side%20lighting%2C%20clean%20white%20background%2C%20contemplative%20expression%2C%20editorial%20portrait%20photography%2C%20high%20contrast&width=600&height=800&seq=testimonial-06&orientation=portrait",
  "article-01": "https://readdy.ai/api/search-image?query=Black%20and%20white%20portrait%20of%20a%20determined%20investigative%20reporter%20in%20profile%2C%20dramatic%20side%20lighting%2C%20clean%20white%20background%2C%20editorial%20portrait%2C%20high%20contrast&width=600&height=800&seq=testimonial-01&orientation=portrait",
  "article-04": "https://readdy.ai/api/search-image?query=Black%20and%20white%20portrait%20of%20a%20confident%20young%20person%20in%20profile%2C%20dramatic%20side%20lighting%2C%20clean%20white%20background%2C%20editorial%20portrait%2C%20high%20contrast&width=600&height=800&seq=testimonial-04&orientation=portrait",
};

export default function Article() {
  const { slug } = useParams<{ slug: string }>();
  const article = slug ? getArticleBySlug(slug) : undefined;
  const relatedArticles = slug ? getRelatedArticles(slug, 4) : [];
  const category = categories.find((c) => c.slug === article?.category);

  if (!article) {
    return (
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-16">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-20 text-center">
            <h1 className="text-2xl font-heading font-bold text-foreground-950">文章未找到</h1>
            <Link to="/" className="mt-4 inline-block text-primary-500 hover:text-primary-600 cursor-pointer">返回首页</Link>
          </div>
        </main>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <article className="w-full pt-20 pb-16">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6">
            <Breadcrumb
              items={[
                ...(category ? [{ label: category.name, href: `/category/${category.slug}` }] : []),
                { label: article.title },
              ]}
            />

            <div className="flex flex-col lg:flex-row gap-12 mt-8">
              <div className="lg:w-[40%]">
                <span className="inline-block px-3 py-1 border border-accent-300 text-xs text-accent-700 rounded-full bg-accent-50">
                  独家爆料
                </span>

                <h1 className="mt-6 text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950 leading-tight">
                  {article.title}
                </h1>
                <p className="mt-2 text-xl md:text-2xl font-heading font-light text-foreground-600 leading-tight">
                  背后真相令人震惊
                </p>

                <p className="mt-8 text-foreground-700 leading-relaxed">
                  {article.content}本报道基于多方信源交叉验证，力求还原事件全貌。我们将持续关注事件进展，为读者带来第一手消息。
                </p>

                <div className="mt-6">
                  <span className="text-sm text-primary-500 font-medium underline cursor-pointer">
                    查看完整视频
                  </span>
                </div>

                <div className="flex items-center gap-8 mt-12">
                  <div className="text-right">
                    <span className="block text-2xl md:text-3xl font-heading font-bold text-foreground-950">{article.views}</span>
                    <span className="text-xs text-foreground-500">阅读量</span>
                  </div>
                  <div className="text-right">
                    <span className="block text-2xl md:text-3xl font-heading font-bold text-foreground-950">{article.comments}</span>
                    <span className="text-xs text-foreground-500">评论数</span>
                  </div>
                </div>

                <div className="mt-8 flex items-center gap-4 text-sm text-foreground-500">
                  <span><i className="ri-calendar-line mr-1"></i>{article.date}</span>
                  <span><i className="ri-user-line mr-1"></i>{article.author}</span>
                </div>
              </div>

              <div className="lg:w-[60%] relative">
                <div className="flex gap-4">
                  <div className="w-[35%] pt-0">
                    <img
                      src={squareImageMap[article.imageSeq] || squareImageMap["article-01"]}
                      alt={article.title}
                      className="w-full rounded-xl object-cover aspect-square"
                      title={article.title}
                    />
                  </div>
                  <div className="w-[60%]">
                    <img
                      src={articleDetailImageMap[article.imageSeq] || articleDetailImageMap["article-01"]}
                      alt={article.title}
                      className="w-full rounded-xl object-cover aspect-[3/4]"
                      title={article.title}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="max-w-[1400px] mx-auto px-4 md:px-6 mt-16">
            <div className="bg-background-100 rounded-xl p-6 md:p-10">
              <h2 className="text-lg font-heading font-bold text-foreground-950 mb-4">原始爆料内容</h2>
              <pre className="text-sm text-foreground-700 font-mono whitespace-pre-wrap leading-relaxed overflow-x-auto">
{`爆料来源：匿名知情人士
提交时间：${article.date}
状态：已核实

=== 以下是完整爆料内容 ===

据可靠消息源透露，${article.title.replace("：", "，")}此前已有多次类似的传闻在圈子内流传，但一直未被证实。本次爆料提供了详实的证据材料，包括时间线梳理、关键人物关系图谱以及现场目击者的证词。

在接到爆料后，我们的调查团队第一时间联系了当事人及相关方进行核实。截至发稿前，当事人方面尚未给出正式回应。

我们呼吁广大网友理性吃瓜，不传谣不信谣，一切以官方通报为准。`}
              </pre>
            </div>
          </div>

          <div className="max-w-[1400px] mx-auto px-4 md:px-6 mt-16">
            <div className="flex flex-col lg:flex-row gap-0 bg-background-50 rounded-xl overflow-hidden">
              <div className="lg:w-[60%] px-6 md:px-10 py-12 md:py-16">
                <div className="flex items-center gap-2 mb-8">
                  <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                  <span className="text-sm font-medium text-foreground-700">神评有话说</span>
                </div>

                <blockquote className="max-w-[80%]">
                  <span className="text-5xl md:text-7xl font-heading text-foreground-300 leading-none">&ldquo;</span>
                  <p className="text-xl md:text-2xl lg:text-3xl font-heading text-foreground-950 leading-snug -mt-4">
                    这次爆料的可信度非常高，信息源和证据链都很完整，算是近期最靠谱的大瓜之一。
                  </p>
                </blockquote>

                <div className="mt-8 flex items-center gap-3">
                  <span className="text-sm font-bold text-foreground-950">吃瓜群众001</span>
                  <span className="flex items-center gap-1 text-xs text-accent-600">
                    <i className="ri-verified-badge-fill text-accent-500"></i>
                    金牌瓜友
                  </span>
                </div>
              </div>

              <div className="lg:w-[40%]">
                <img
                  src={testimonialImageMap[article.imageSeq] || testimonialImageMap["article-06"]}
                  alt="评论者肖像"
                  className="w-full h-full object-cover min-h-[300px] lg:min-h-[400px]"
                  title="金牌瓜友 - 吃瓜群众001"
                />
              </div>
            </div>
          </div>

          {article.tags && article.tags.length > 0 && (
            <div className="max-w-[1400px] mx-auto px-4 md:px-6 mt-12">
              <div className="flex items-center gap-2 flex-wrap">
                <span className="text-sm text-foreground-500">标签：</span>
                {article.tags.map((tag) => (
                  <span key={tag} className="px-3 py-1 bg-secondary-100 text-secondary-700 text-xs font-medium rounded-full">{tag}</span>
                ))}
              </div>
            </div>
          )}
        </article>

        {relatedArticles.length > 0 && (
          <section className="w-full py-16 bg-background-100">
            <div className="max-w-[1400px] mx-auto px-4 md:px-6">
              <h2 className="text-2xl font-heading font-bold text-foreground-950 mb-10">相关爆料</h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
                {relatedArticles.map((ra) => (
                  <Link
                    key={ra.slug}
                    to={`/article/${ra.slug}`}
                    className="group relative rounded-xl overflow-hidden bg-background-50 cursor-pointer"
                  >
                    <div className="aspect-[4/3] w-full">
                      <img
                        src={squareImageMap[ra.imageSeq] || squareImageMap["article-01"]}
                        alt={ra.title}
                        className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                        title={ra.title}
                      />
                    </div>
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                    <div className="absolute bottom-0 left-0 right-0 p-4">
                      <h3 className="text-white text-sm font-heading font-bold leading-snug line-clamp-2">{ra.title}</h3>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </section>
        )}

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "Article",
              headline: article.title,
              image: "https://readdy.ai/api/search-image?query=Dramatic%20investigative%20journalism%20with%20warm%20amber%20lighting%20and%20moody%20cinematic%20atmosphere%20editorial%20photography&width=800&height=600&seq=article-schema-img&orientation=landscape",
              datePublished: article.date,
              dateModified: article.date,
              author: {
                "@type": "Person",
                name: article.author || "每日吃瓜黑料",
                url: `${typeof window !== "undefined" ? window.location.origin : "http://28i7.com/"}/about`,
              },
              publisher: {
                "@type": "Organization",
                name: "每日吃瓜黑料",
                url: "http://28i7.com/",
                logo: "https://readdy.ai/api/search-image?query=Minimalist%20modern%20logo%20placeholder%20on%20clean%20white%20background%2C%20simple%20geometric%20shape%2C%20warm%20amber%20tones%2C%20professional%20brand%20identity%20design&width=200&height=200&seq=logo-schema&orientation=squarish",
              },
              description: article.excerpt,
              articleSection: category?.name || "爆料",
              keywords: article.tags?.join(", ") || "吃瓜, 黑料, 爆料",
              wordCount: article.content.length,
              mainEntityOfPage: {
                "@type": "WebPage",
                "@id": `${typeof window !== "undefined" ? window.location.origin : "http://28i7.com/"}/article/${article.slug}`,
              },
              interactionStatistic: [
                {
                  "@type": "InteractionCounter",
                  interactionType: "https://schema.org/ViewAction",
                  userInteractionCount: parseInt(article.views.replace(/[^0-9]/g, "")) || 0,
                },
                {
                  "@type": "InteractionCounter",
                  interactionType: "https://schema.org/CommentAction",
                  userInteractionCount: article.comments,
                },
              ],
            }),
          }}
        />

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "FAQPage",
              mainEntity: [
                {
                  "@type": "Question",
                  name: `关于"${article.title}"的最新进展是什么？`,
                  acceptedAnswer: {
                    "@type": "Answer",
                    text: `目前事件仍在持续发酵中，我们将第一时间更新最新进展。截至${article.date}，已有${article.views}人次关注此事，${article.comments}条评论热议。`,
                  },
                },
                {
                  "@type": "Question",
                  name: "这个爆料的真实性如何？",
                  acceptedAnswer: {
                    "@type": "Answer",
                    text: "本爆料经过多方信源交叉验证，提供的证据材料详实可靠。我们建议网友理性吃瓜，以官方通报为准。",
                  },
                },
                {
                  "@type": "Question",
                  name: "在哪里可以看到更多相关爆料？",
                  acceptedAnswer: {
                    "@type": "Answer",
                    text: "更多相关爆料请关注每日吃瓜黑料网站，我们每日更新最新最热的黑料内容，涵盖网红八卦、明星绯闻、社会热点等多个频道。",
                  },
                },
                {
                  "@type": "Question",
                  name: "每日吃瓜黑料如何保护爆料人隐私？",
                  acceptedAnswer: {
                    "@type": "Answer",
                    text: "我们采用严格的隐私保护机制，所有匿名爆料人的身份信息均经过加密处理，不会在任何情况下泄露给第三方。",
                  },
                },
              ],
            }),
          }}
        />

      </main>
      <Footer />
    </div>
  );
}